import cortarTexto from './cortar-texto'
import formataCpfCnpj from './formata-cpf-cnpj'
import formatarData from './formatar-data'
import textoSemValor from './texto-sem-valor'
import textoSemValorSimples from './texto-sem-valor-simples'
import valorParaDinheiro from './valor-para-dinheiro'

export default {
    install(Vue) {
        Vue.filter('textoSemValor', textoSemValor)
        Vue.filter('textoSemValorSimples', textoSemValorSimples)
        Vue.filter('valorParaDinheiro', valorParaDinheiro)
        Vue.filter('cortarTexto', cortarTexto)
        Vue.filter('formatarData', formatarData)
        Vue.filter('formataCpfCnpj', formataCpfCnpj)
    },
}
